@file:OptIn(ExperimentalSerializationApi::class)
package com.gsb.vyapar.bhagya.domain

import com.gsb.vyapar.bhagya.datasource.network.Dto
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class Config(
    val v: Int = 0,
    val d: D = D()
) {
    @Serializable
    data class D(
        val config: Map<String, Int> = mapOf()
    )
}

fun Dto.toConfig(): Config {
    return Config(v = v, d = ProtoBuf.decodeFromByteArray<Config.D>(d.decodeBase64Bytes().uncompress(GZIP)))
}

fun Config.toDto(): Dto {
    return Dto(v = v, d = ProtoBuf.encodeToByteArray(d).compress(GZIP).encodeBase64())
}

fun String.decodeConfigString(): Config {
    return try {
        if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
            return Config()
        }
        ProtoBuf.decodeFromByteArray<Config>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        Config()
    }
}

fun Config.encodeConfigString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun Config.getInfoVersion(): Int {
    return this.d.config[INFO] ?: 0
}

fun Config.getCategoryVersion(): Int {
    return this.d.config[CATEGORY] ?: 0
}

fun Config.getSubCategoryVersion(): Int {
    return this.d.config[SUBCATEGORY] ?: 0
}

fun Config.getBusinessNumber(): Int {
    return this.d.config[BUSINESS] ?: 1
}